module.exports = __webpack_public_path__ + "static/media/MarieeJuarez.038bd80d.png";